import { mergeObjects } from '@/helpers/ObjectHelpers';
import CmsApiEndpoints from '@/config/apiEndpoints/Cms';
import AuthApiEndpoints from '@/config/apiEndpoints/Auth';
import UserApiEndpoints from '@/config/apiEndpoints/Users';
import OrderApiEndpoints from '@/config/apiEndpoints/Orders';
import GiftApiEndpoints from '@/config/apiEndpoints/Gifting';
import CouponApiEndpoints from '@/config/apiEndpoints/Coupons';
import CanvasserEndpoints from '@/config/apiEndpoints/Canvasser';
import PaymentsApiEndpoints from '@/config/apiEndpoints/Payments';
import LogisticApiEndpoints from '@/config/apiEndpoints/Logistics';
import SubscriptionApiEndpoints from '@/config/apiEndpoints/Subscriptions';
import ShopEndpoints from '@/config/apiEndpoints/Shop';

export default mergeObjects([
    CmsApiEndpoints,
    AuthApiEndpoints,
    UserApiEndpoints,
    OrderApiEndpoints,
    GiftApiEndpoints,
    CouponApiEndpoints,
    CanvasserEndpoints,
    PaymentsApiEndpoints,
    LogisticApiEndpoints,
    SubscriptionApiEndpoints,
    ShopEndpoints,
]);
